import { Customer, Invoice } from './types';

export type ICreateIncassoState = {
  activeWindow: 'SELECT_CUSTOMER' | 'SELECT_INVOICES' | 'OVERVIEW';
  selectedCustomer: Customer | null;
  selectedInvoices: Invoice[];
};

export type CreateIncassoAction =
  | {
      type: 'SELECT_CUSTOMER';
      customer: Customer | null;
    }
  | {
      type: 'SELECT_INVOICE';
      invoice: Invoice;
    }
  | {
      type: 'GO_BACK';
    }
  | { type: 'GO_FORWARD' };

export function createIncassoReducer(state: ICreateIncassoState, action: CreateIncassoAction): ICreateIncassoState {
  switch (action.type) {
    case 'SELECT_CUSTOMER': {
      return {
        ...state,
        selectedCustomer: action.customer,
        selectedInvoices: [],
        activeWindow: action.customer ? 'SELECT_INVOICES' : 'SELECT_CUSTOMER',
      };
    }
    case 'SELECT_INVOICE': {
      let invoices = [...state.selectedInvoices];
      if (invoices.some((i) => i.id === action.invoice.id)) {
        invoices = invoices.filter((i) => i.id !== action.invoice.id);
      } else {
        invoices.push(action.invoice);
      }

      return {
        ...state,
        selectedInvoices: invoices,
      };
    }
    case 'GO_BACK': {
      let newWindow = state.activeWindow;
      if (state.activeWindow === 'OVERVIEW') {
        newWindow = 'SELECT_INVOICES';
      } else if (state.activeWindow === 'SELECT_INVOICES') {
        newWindow = 'SELECT_CUSTOMER';
      }

      return {
        ...state,
        activeWindow: newWindow,
      };
    }
    case 'GO_FORWARD': {
      let newWindow = state.activeWindow;
      if (state.activeWindow === 'SELECT_CUSTOMER') {
        newWindow = 'SELECT_INVOICES';

        if (state.selectedCustomer === null) {
          console.warn('No customer selected, staying in SELECT_CUSTOMER window');
          return state;
        }
      } else if (state.activeWindow === 'SELECT_INVOICES') {
        newWindow = 'OVERVIEW';

        if (state.selectedInvoices.length === 0) {
          console.warn('No invoices selected, staying in SELECT_INVOICES window');
          return state;
        }
      }

      return {
        ...state,
        activeWindow: newWindow,
      };
    }
  }

  return state;
}
